export default __webpack_public_path__ + "static/work-e0b2cf6d814d453be27f1e76ea031268.png";